import { Endpoint } from '../endpoint';
import { FontResponse } from '@business/entities/google';

export function fonts(search: string) {
  return Endpoint.get<FontResponse[]>('@makh/google/fonts', { params: { search } });
}
